import { Helmet } from 'react-helmet';

const SchemaMarkup = () => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "name": "Nutrillion",
              "url": "https://www.nutrillion.one/",
              "logo": "https://www.nutrillion.one/Logo_DP.png",
              "description": "Nutrillion is a personalized nutrition platform using genetics and nutrigenomics to deliver precision-driven health solutions.",
              "sameAs": ["https://www.linkedin.com/company/nutrivison-wellness-and-genetics-private-limited"]
            },
            {
              "@type": "WebSite",
              "url": "https://www.nutrillion.one/",
              "name": "Nutrillion",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.nutrillion.one/?s={search_term_string}",
                "query-input": "required name=search_term_string"
              }
            },
            {
              "@type": "WebApplication",
              "name": "Nutrillion App",
              "url": "https://www.nutrillion.one/",
              "applicationCategory": "HealthApplication",
              "operatingSystem": "Android, Web",
              "description": "A personalized nutrition app connecting users with expert nutritionists for DNA-based diet and wellness plans.",
              "creator": {
                "@type": "Organization",
                "name": "Nutrillion"
              }
            },
            {
              "@type": "MedicalBusiness",
              "name": "Nutrillion",
              "url": "https://www.nutrillion.one/",
              "medicalSpecialty": "Nutrition",
              "areaServed": "India",
              "description": "Offering personalized nutrition programs, DNA-based diet plans to celebrities & sport person, and nutrigenomics consultations."
            },
            {
              "@type": "Person",
              "name": "Dr. Rishabh Verma",
              "jobTitle": "Founder & MD",
              "worksFor": {
                "@type": "Organization",
                "name": "Nutrillion"
              }
            },
            {
              "@type": "Service",
              "serviceType": "Personalized Nutrition Consultation",
              "provider": {
                "@type": "Organization",
                "name": "Nutrillion"
              },
              "areaServed": "India",
              "description": "DNA-based personalized nutrition plans using genetic insights and lifestyle data to improve health outcomes."
            },
            {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What is personalized nutrition?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Personalized nutrition uses genetics, lifestyle, and health data to create customized diet plans tailored to an individual."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How does DNA affect nutrition?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "DNA influences how your body processes nutrients, reacts to foods, and impacts metabolism, making personalized diets more effective."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is nutrigenomics?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Nutrigenomics studies how genes interact with nutrients to optimize health and prevent diseases."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Who should use DNA-based diet plans?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Anyone looking to improve health, manage weight, or prevent diseases can benefit from DNA-based personalized nutrition plans."
                  }
                }
              ]
            }
          ]
        }
        `}
      </script>
    </Helmet>
  );
};

export default SchemaMarkup;